import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentComparisonApiService } from 'src/services/contentComparisonApi'

// The report. Computed by the server on every read, so this is deliberately not
// cached for long: reopening a comparison should show the posts and comments
// that have landed since, which is the whole point of computing it live.
const STALE_MS = 30 * 1000

export const useGetContentComparisonQuery = (comparisonId?: string) =>
  useQuery({
    enabled: !!comparisonId,
    queryFn: () => ContentComparisonApiService.getOne(comparisonId as string),
    queryKey: [QueryKey.GET_CONTENT_COMPARISON, comparisonId],
    staleTime: STALE_MS,
  })
